import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
  capturePageview,
  identifyUser,
  initPostHog,
  resetAnalyticsUser,
} from '../analytics/posthog';
import { useAuth } from '../context/AuthContext';

/** Initializes PostHog, tracks SPA pageviews, and syncs auth identity. */
const PostHogProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { pathname, search } = useLocation();
  const { user } = useAuth();

  useEffect(() => {
    initPostHog();
    capturePageview(`${pathname}${search}`);
  }, [pathname, search]);

  useEffect(() => {
    if (user === undefined) {
      return;
    }
    if (user === null) {
      resetAnalyticsUser();
      return;
    }
    identifyUser(user);
  }, [user]);

  return <>{children}</>;
};

export default PostHogProvider;
